export const emptyCartmateIcon = require('./images/empty-cartmate-icon.svg');